<template>
  <div id="Welcome">
    <!--Title-->
    <div class="row">
      <h4 class="col-xs-12 card-title csp-card-title">Welcome {{ givenName || authName }}</h4>
    </div>
    <!--Text-->
    <div class="row">
      <div class="col-xs-12 ">
        <p class="card-text csp-welcome-text">Since this is your first time logging in to Courtyard Stone & Landscape’s client service portal this year, we’d like to ask you to validate your information to make sure our records are accurate.</p>
      </div>                
    </div>
  </div>           
</template>

<script>
  import {mapGetters} from 'vuex'
  
  export default {
    name: 'Welcome',
    computed: {
      ...mapGetters([
        'authName',
        'givenName'
      ])
    }
  }
</script>

<style scoped>
  
  .csp-welcome-text{
    text-align: justify;
  }
  


  /* All Mobile Sizes (devices and browser) */
  @media only screen and (max-width: 767px) {



  }
  
  @media only screen and (min-width: 480px) and (max-width: 767px) {

  }
  
  
  @media only screen and (max-width: 479px) {

  }
</style>



// WEBPACK FOOTER //
// Welcome.vue?5d27bf7e